import React, { useCallback, useMemo } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const PRESCRIPTION_OPTIONS = [
    { id: 'prescription-all', selectValue: '', label: 'Todos los productos' },
    { id: 'prescription-with', selectValue: 'true', label: 'Solo con prescripción veterinaria' },
    { id: 'prescription-without', selectValue: 'false', label: 'Sin prescripción veterinaria' },
];

/**
 * @param {string} input - Raw string value from the radio element
 * @returns {boolean | null}
 */
const normalizeVetPrescriptionValue = (input) => {
    if (input === 'true') return true;
    if (input === 'false') return false;
    return null;
};

/**
 * @param {boolean | null | undefined} value - The vetPrescription filter state
 * @returns {string}
 */
const getVetPrescriptionSelectValue = (value) => {
    if (value === true) return 'true';
    if (value === false) return 'false';
    return '';
};

/**
 * @param {{
 *   options: any,
 *   value: { prescription: boolean | null } | null | undefined,
 *   onChange: (val: { prescription: boolean | null }) => void
 * }} props
 * @returns {JSX.Element}
 */
export const CharacteristicsFilterUI = ({ options, value, onChange }) => {
    const prescription = useMemo(() => value?.prescription, [value]);
    const currentValue = getVetPrescriptionSelectValue(prescription);

    const handleChange = useCallback(
        (e) => {
            const normalized = normalizeVetPrescriptionValue(e.target.value);
            onChange({ prescription: normalized });
        },
        [onChange]
    );

    return (
        <Accordion className="taxonomy-dropdowns">
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="prescription-filter-content"
            >
                <span>Prescripción</span>
                {prescription != null && (
                    <span className="badge rounded-pill bg-primary ms-2">1</span>
                )}
            </AccordionSummary>
            <AccordionDetails>
                {PRESCRIPTION_OPTIONS.map(({ id, selectValue, label }) => (
                    <div key={id} className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="prescription"
                            id={id}
                            value={selectValue}
                            checked={currentValue === selectValue}
                            onChange={handleChange}
                        />
                        <label
                            className={`form-check-label ${currentValue === selectValue && selectValue !== '' ? 'fw-semibold' : ''}`}
                            htmlFor={id}
                        >
                            <small>{label}</small>
                        </label>
                    </div>
                ))}
            </AccordionDetails>
        </Accordion>
    );
};
